import useScrollToFormAndAnimate from "@Form/hooks/useScrollToFormAndAnimate";
import FormErrorsModel from "@Form/models/FormErrorsModel";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {setFormErrors} from "../reducers/formSlice";
import {serialize} from "@Object/serialize";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {
    activateDepartureStationInput,
    activateDestinationStationInput,
    activateSingleCalendar
} from "@Reducers/mobileSlice";

export default function useValidateForm() {
    const {urlParams} = useAppSelector((state) => state?.form)
    const {animateForm} = useScrollToFormAndAnimate()
    const dispatch = useAppDispatch()
    const isMobile = useIsMobile()

    const checkForErrors = () => {
        const formErrors = new FormErrorsModel(urlParams)
        const noErrors = Object.values(formErrors).every((field) => field === true)

        // Always set form errors regardless of mobile state
        dispatch(setFormErrors(serialize(formErrors)))

        // Mobile-specific UI behavior (but don't return early)
        if (!noErrors && isMobile) {
            animateForm()
        }

        // Note: Removed automatic input field activation during validation
        // This was causing the form to switch to individual input views instead
        // of staying on the main form with validation errors

        // Always return the validation result
        return noErrors
    }

    return {
        checkForErrors,
    }
}